import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { enhancedConnect } from "../../utils";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var _Image = function _Image(_ref) {
  var size = _ref.size,
    src = _ref.src,
    alt = _ref.alt,
    className = _ref.className,
    height = _ref.height,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'center' : _ref$position,
    isBackground = _ref.isBackground,
    style = _ref.style,
    children = _ref.children,
    borderRadius = _ref.borderRadius,
    width = _ref.width,
    bgColor = _ref.bgColor;
  if (isBackground) {
    return /*#__PURE__*/React.createElement("div", {
      "aria-hidden": true,
      "aria-label": alt,
      className: cn('image', className),
      style: _objectSpread({
        backgroundImage: src ? "url(".concat(src, ")") : undefined,
        height: height,
        backgroundPosition: position,
        backgroundSize: size,
        backgroundRepeat: 'no-repeat',
        width: width,
        borderRadius: borderRadius,
        backgroundColor: bgColor
      }, style),
      "data-t-id": "components-Image"
    }, children);
  }
  return /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: className,
    height: height,
    src: src,
    style: _objectSpread({
      objectFit: size,
      objectPosition: position,
      width: width,
      height: height,
      display: 'block',
      borderRadius: borderRadius,
      backgroundColor: bgColor
    }, style),
    width: width
  });
};
export var Image = enhancedConnect({
  alt: PropTypes.string,
  bgColor: PropTypes.string,
  borderRadius: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.string,
  isBackground: PropTypes.bool,
  position: PropTypes.oneOfType([PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'center']), PropTypes.string]),
  size: PropTypes.oneOfType([PropTypes.oneOf(['contain', 'cover']), PropTypes.string]),
  src: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.string
})(_Image);
Image.defaultProps = {
  position: 'center',
  height: '100%',
  width: '100%',
  bgColor: 'transparent',
  size: 'none',
  borderRadius: '0px'
};